import request from "../utils/fetch";

// 充值套餐列表
export function topList(data) {
  return request({
    url: "/order/water/ticket/package/admin/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 充值套餐列表--下拉
export function topListPull(data) {
  return request({
    url: "/order/water/ticket/package/admin/down",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 充值套餐删除
export function topDel(data) {
  return request({
    url: "/order/water/ticket/package/del",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 分区下拉接口
export function allZonePull(data) {
  return request({
    url: "/equipment/region/pull/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 套餐新增
export function topAdd(data) {
  return request({
    url: "/order/water/ticket/package/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 套餐编辑
export function topEdit(data) {
  return request({
    url: "/order/water/ticket/package/edit",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function white_list(data) {
  return request({
    url: "/order/activity/package/white/get/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function white_add(data) {
  return request({
    url: "/order/activity/package/white/insert",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}


export function white_userpullList(data) {
  return request({
    url: "/user/afterSales/new/user/pullList2",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function white_delete(data) {
  return request({
    url:"/order/activity/package/white/delete",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function performance_list(data) {
  return request({
    url:"/order/performance/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}


export function region_list(data) {
  return request({
    url:"/order/performance/region/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}